import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/Events.css";
import { FaArrowRight } from "react-icons/fa";
import ServicesKnoweldgeRegister from "../components/ServicesKnoweldgeRegister";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import upcoming1 from "../assets/upcoming1.png";
import upcoming2 from "../assets/upcoming2.png";
import past1 from "../assets/past1.png";
import past2 from "../assets/past2.png";
import { useNavigate } from "react-router-dom";

const upcomingEvents = [
  {
    title: "HR EVENT",
    organizer: "Y. Siva Krishna",
    speaker: "K. Rajasekhar",
    eventmode: "online",
    schedule: "Aug 20 - Aug 23",
    time: "10AM - 4PM",
    location: "Hyderabad",
    image: upcoming1,
    button: "REGISTER NOW",
  },
  {
    title: "KNOWLEDGE",
    organizer: "Y. Siva Krishna",
    speaker: "K. Rajasekhar",
    eventmode: "online",
    schedule: "Jun 20 - Jun 23",
    time: "10AM - 4PM",
    location: "Kakinada",
    image: upcoming2,
    button: "REGISTER NOW",
  },
  {
    title: "HR EVENT",
    organizer: "Y. Siva Krishna",
    speaker: "K. Rajasekhar",
    eventmode: "online",
    schedule: "Aug 20 - Aug 23",
    time: "10AM - 4PM",
    location: "Hyderabad",
    image: upcoming1,
    button: "REGISTER NOW",
  },
  {
    title: "KNOWLEDGE",
    organizer: "Y. Siva Krishna",
    speaker: "K. Rajasekhar",
    eventmode: "online",
    schedule: "Jun 20 - Jun 23",
    time: "10AM - 4PM",
    location: "Kakinada",
    image: upcoming2,
    button: "REGISTER NOW",
  },
];

const pastEvents = [
  {
    title: "HR EVENT",
    organizer: "Y. Siva Krishna",
    speaker: "K. Rajasekhar",
    eventmode: "online",
    schedule: "Aug 20 - Aug 23",
    time: "10AM - 4PM",
    location: "Hyderabad",
    image: past1,
    button: "COMPLETED",
  },
  {
    title: "JOB DRIVE",
    organizer: "Y. Siva Krishna",
    speaker: "K. Rajasekhar",
    eventmode: "Virtual",
    schedule: "Aug 20 - Aug 23",
    time: "10AM - 4PM",
    location: "Hyderabad",
    image: past2,
    button: "COMPLETED",
  },
  {
    title: "HR EVENT",
    organizer: "Y. Siva Krishna",
    speaker: "K. Rajasekhar",
    eventmode: "online",
    schedule: "Aug 20 - Aug 23",
    time: "10AM - 4PM",
    location: "Hyderabad",
    image: past1,
    button: "COMPLETED",
  },
  {
    title: "JOB DRIVE",
    organizer: "Y. Siva Krishna",
    speaker: "K. Rajasekhar",
    eventmode: "In person",
    schedule: "Aug 20 - Aug 23",
    time: "10AM - 4PM",
    location: "Hyderabad",
    image: past2,
    button: "COMPLETED",
  },
];

export default function Events() {


  const eventSlider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1 }
      },
      {
        breakpoint: 575,
        settings: { slidesToShow: 1, slidesToScroll: 1 }
      },
    ],
  };




  const navigate = useNavigate();

  const renderCard = (event, index) => (
    <div key={index} className="p-2">
      <div className="event-card d-flex justify-content-between align-items-center gap-3 p-3">
        <div className="event-info">
          <p>
            <strong>Event Title :</strong> {event.title}
          </p>
          <p>
            <strong>Organizer Name :</strong> {event.organizer}
          </p>
          <p>
            <strong>Speaker Name :</strong> {event.speaker}
          </p>
          <p>
            <strong>Event Mode :</strong> {event.eventmode}
          </p>
          <p>
            <strong>Event Schedule :</strong> {event.schedule}
          </p>
          <p>
            <strong>Time :</strong> {event.time}
          </p>
          <p>
            <strong>Location :</strong> {event.location}
          </p>

          {event.button === "COMPLETED" ? (
            <span className="btn btn-secondary register-btn1 completed-btn">
              COMPLETED
            </span>
          ) : (
            <button
              className="btn btn-success register-btn1"
              onClick={openPopup}
            >
              REGISTER NOW
            </button>
          )}

        </div>

        <div className="event-img">
          <img src={event.image} alt={event.title} className="img-fluid" />
        </div>
      </div>
    </div>
  );

  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => setShowPopup(true);
  const closePopup = () => setShowPopup(false);


  return (
    <div className="container my-5 p-5 h-1oovh " id="events">
      <div className="text-center mb-4">
        <h3 className="section-title mt-5">EVENTS</h3>
      </div>

      {/* ---------- UPCOMING EVENTS ---------- */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="section-subtitle">Upcoming Events :</h5>
        <button onClick={() => navigate('/Upcommingevents')} className="view-all-bten">
          View All <FaArrowRight />
        </button>
      </div>

      <Slider {...eventSlider}>
        {upcomingEvents.map((e, i) => renderCard(e, i))}
      </Slider>

      {/* ---------- PAST EVENTS ---------- */}
      <div className="d-flex justify-content-between align-items-center mb-3 mt-5">
        <h5 className="section-subtitle">Past / Completed Events :</h5>
        <button onClick={() => navigate('/Pastcompletedevents')} className="view-all-bten">
          View All <FaArrowRight />
        </button>
      </div>

      <Slider {...eventSlider}>
        {pastEvents.map((e, i) => renderCard(e, i))}
      </Slider>
      <ServicesKnoweldgeRegister show={showPopup} onClose={closePopup} />
    </div>
  );
}
